/*
* Lomtec jQuery startup
*/
$(document).ready(function () {
    if (typeof ContactPage !== 'undefined') ContactPage.initMap(); //to do - only for contact page

    // init jquery ajax loader
    initAjax();

    // custom form controls init
    initFormControls($(document));

});

function initFormControls($container) {

    initDatePicker($container);
    initAdvancedSearch($container);
    initPaging($container);

    // bootstrap tooltips
    $('[data-toggle="tooltip"]', $container).tooltip({
        placement: 'right',
        container: false
    });

    // init confirmations
    $('[data-confirm]', $container).each(function () {
        var $a = $(this);
        $a.confirmDialog();
    });
}

function initAjax() {
    //var timeoutHandler;
    //$(document).ajaxStart(function () {
    //    timeoutHandler = setTimeout(function () {
    //        $.LoadingOverlay("show", {
    //            image: "",
    //            fontawesome: "fa fa-spinner fa-spin"
    //        });
    //    }, 1500);
    //});

    //$(document).ajaxStop(function () {
    //    clearTimeout(timeoutHandler);
    //    $.LoadingOverlay("hide");
    //});

    //$(document).ajaxError(function (event, request) {
    //    $.LoadingOverlay("hide");
    //    // check for unauthorized code and redirect full page to login
    //    if (request.status === 401 || request.status === 403) window.location = "client/";
    //});

    //$(document).ajaxComplete(function (event, request, settings) {
    //    console.log("Ajax Request Complete: " + settings.url + ", " + request.status);
    //});
}

function initAdvancedSearch($container) {
    $('.advanced', $container).click(function () {
        $('.advancedSearchBox', $container).slideToggle(200);
    });
}

function initDatePicker($container) {
    $('input[data-val-date]', $container).not('[readonly], [disabled]').each(function () {
        if ($(this).attr('data-val-minDateElement')) {

            var $minDate = $("#" + $(this).attr('data-val-minDateElement'));

            $(this).datepicker({
                onSelect: function (selected) {
                    $minDate.datepicker("option", "minDate", selected);
                },
                defaultDate: $(this).val(),
                maxDate: $minDate.val()
            });
        }
        if ($(this).attr('data-val-maxDateElement')) {

            var $maxDate = $("#" + $(this).attr('data-val-maxDateElement'));

            $(this).datepicker({
                onSelect: function (selected) {
                    $maxDate.datepicker("option", "maxDate", selected);
                },
                defaultDate: $(this).val(),
                minDate: $maxDate.val()
            });
        }
        else {
            $(this).datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "-100:+20",
                onSelect: function (selected) {
                    $(this).focus().valid();
                }
            });
        }
    });
}

function initPaging($container) {
    $('.pager-pagesize', $container).on('change', function (e) {
        var self = $(this);
        var option = self.find("option[value=" + self.val() + "]:first");
        self.data('pager-pagesize', self.val());
        if (self.hasClass('ajax-processed')) return;
        window.location.href = option.attr('data-redirect');
    });
}

//ajax loader for lists
(function () {
    var a, b, c, d = 1,
        e = function () {
            $(".ajax-load").length > 0 && (f(), $(".ajax-load-more").on("click", function () {
                return $(this).addClass("hidden"), d = parseInt($(".ajax-load").attr("data-page")), d += 1, $(".ajax-load").attr("data-page", d), f(), !1
            }), $("a[data-ajax-filter]").on("click", function () {
                return $(".ajax-load-more").addClass("hidden"), $(".ajax-load").attr("data-page", 1), $("a.active[data-ajax-filter]").removeClass("active"), $(this).addClass("active"), f(), !1
            }))
        },
        f = function () {
            $(".ajax-load-more").addClass("hidden"), $(".ajax-preloader").removeClass("hidden"), a = "all", $(".active[data-ajax-filter]").length > 0 && (a = $(".active[data-ajax-filter]").attr("data-ajax-filter")), b = $(".ajax-load").attr("data-ajax-url"), c = $($(".ajax-load").attr("data-container")), d = parseInt($(".ajax-load").attr("data-page")), d <= 1 && c.empty(), $.ajax({
                dataType: "html",
                url: b,
                data: {
                    page: d,
                    filter: a
                },
                method: "post",
                success: function (a) {
                    c.append(a), $(window).trigger("resize"), $(".ajax-preloader").addClass("hidden"), c.find('*[data-lastitem="true"]').length <= 0 && $(".ajax-load-more").removeClass("hidden");
                },
                error: function (a) {
                    console.log("News load / ERROR")
                }
            })
        };
    e()
})();

//search autocomplete (with categories)
(function () {
    $(function () {
        $("#search-input").autocomplete({
            delay: 200,
            width: "100%",
            maxHeight: 550,
            minLength: 3,
            source: 'search-predictive',
            select: function (event, ui) {
                //when autocomplete item is selected, redirect user to page 
                window.location.href = ui.item.URL;

                //or default functionality - on select, copy item's value to searchbox
                //$("#search-input").val(ui.item.Title);
                return false;
            },
            focus: function (event, ui) {
                //on focus, copy item's Title value to searchbox
                //$("#search-input").val(ui.item.Title);
                //return false;
            },
            open: function (event, ui) {
                $(this).autocomplete("widget").css({
                    "width": ($(this).outerWidth() + "px")
                });

                $lilast.appendTo("ul.ui-autocomplete");
            },
            create: function (event, ui) {
                $lilast = $("<li class='search-all border-bottom g-px-30 g-py-15 ui-menu-item text-center'>").html($('#allres').html());
            }
        })
            .autocomplete("instance")._renderItem = function (ul, item) { //custom rendering of items
                var liContent = [
                    //"<a href='" + item.URL + "'>",
                    "<span class='text h6 g-mb-2 text-uppercase g-font-weight-700 g-color-primary d-block'>" + item.Title + "</span>",
                    //(item.Category == '' ? "" : ("<span class='category d-block'> (" + item.Category + ")</span>")),
                    "<span class='annotation'>",
                    item.Annotation,
                    "</span>",
                    //"</a>"
                ].join("");
                return $("<li class='border-bottom g-px-30 g-py-10'>")
                    .append(liContent)
                    .appendTo(ul)
                    .data("item.autocomplete", item);
            };
    });
})();

(function ($) {
    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };
})(jQuery);

//global slide up effect animation
var win = $(window);
var allMods = $(".fade-default");

win.scroll(function (event) {
    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            var fadeClass = "";
            if (typeof el.attr("data-fade-class") !== "undefined") {
                var fadeClass = " " + el.attr("data-fade-class");
            }
            el.addClass("come-in" + fadeClass);
        }
    });

});

$(window).trigger('scroll');
        //global slide up effect animation